import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ClientsPage } from "./pages/ClientsPage";
import { ClientDatasetsPage } from "./pages/ClientDatasetsPage";
import { DatasetDetailPage } from "./pages/DatasetDetailPage";
import { ConsignmentDetailPage } from "./pages/ConsignmentDetailPage";
import { LandingPage } from "./pages/LandingPage";
import { TemperatureProvidersPage } from "./pages/TemperatureProvidersPage";
import { ConfigurationPage } from "./pages/ConfigurationPage";
import { BlulogProvider } from "./features/temperature/blulog/context";
import { BlulogLayout } from "./features/temperature/blulog/BlulogLayout";
import { BlulogDashboardPage } from "./features/temperature/blulog/BlulogDashboardPage";
import { BlulogRefreshPage } from "./features/temperature/blulog/BlulogRefreshPage";
import { AdminAccessPage } from "./pages/AdminAccessPage";
import { DatasetDataManagementPage } from "./features/data-management/DatasetDataManagementPage";
import { SourceRevisionExplorerPage } from "./features/data-management/SourceRevisionExplorerPage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/clients/:clientId" element={<ClientDatasetsPage />} />
        <Route path="/clients/:clientId/datasets/:datasetId" element={<DatasetDetailPage />} />
        <Route
          path="/clients/:clientId/datasets/:datasetId/data-management"
          element={<DatasetDataManagementPage />}
        />
        <Route
          path="/clients/:clientId/datasets/:datasetId/source-explorer"
          element={<SourceRevisionExplorerPage />}
        />
        <Route
          path="/clients/:clientId/datasets/:datasetId/consignments/:consignmentId"
          element={<ConsignmentDetailPage />}
        />
        <Route path="/temperature" element={<TemperatureProvidersPage />} />
        <Route path="/configuration" element={<ConfigurationPage />} />
        <Route path="/admin/access" element={<AdminAccessPage />} />
        <Route
          path="/temperature/blulog"
          element={
            <BlulogProvider>
              <BlulogLayout />
            </BlulogProvider>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<BlulogDashboardPage />} />
          <Route path="refresh-data" element={<BlulogRefreshPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
